import mitgliederSearchData from '@/shared/model/smallPayloadModels/mitgliederSearchData';
import { TblMitgliederState } from './types';

export const state = (): TblMitgliederState => initialState();

export const initialState = (): TblMitgliederState => ({
  mitgliederSearchData: mitgliederSearchData.defaultData(),
  tblMitglieders: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
      andClauseFieldsIds: [],
    },
  },
});
